<script setup lang="ts">
const props = defineProps({
  price: {
    type: Object as PropType<BasePrice>,
    required: false,
    default: null,
  },
  originalPrice: {
    type: Object as PropType<BasePrice>,
    required: false,
    default: null,
  },
  nextPrice: {
    type: Object as PropType<BasePrice>,
    required: false,
    default: null,
  },
  recommendedPrice: {
    type: Object as PropType<BasePrice>,
    required: false,
    default: null,
  },
  text: {
    type: String,
    required: true,
  },
  showRecommendedPrice: {
    type: Boolean,
    required: false,
    default: false,
  },
  startDate: {
    type: String,
    required: false,
    default: null,
  },
});

const showComingSoon = computed(() => {
  const now = new Date();
  if (props.price?.GFAL === 0) return true;
  if (props.startDate) {
    const start = new Date(props.startDate);
    if (start > now) return true;
  }
  return false;
});
</script>

<template>
  <div
    class="py-5 px-7 sm:pr-0 last-of-type:border-b-0 border-b-2 border-primary-900 flex flex-col sm:flex-row gap-4 sm:flex-wrap">
    <div class="flex flex-col shadow-xs">
      <p class="text-neutral-200 text-xs font-semibold pb-2">{{ text }}</p>
      <div class="flex-1 relative flex price-layout">
        <BaseIcon
          name="GFAL_token"
          class="w-8 price-layout__icon"
          :alt="$t('main.imageAltTexts.GFALTokenLogo')" />
        <p class="text-2xl text-neutral-200 font-bold">
          {{
            showComingSoon
              ? $t("main.home.comingSoon")
              : roundNum(price?.GFAL || recommendedPrice?.GFAL)
          }}
        </p>
        <template v-if="!showComingSoon">
          <p class="text-neutral-200 price-layout__token-label">GFAL</p>
          <div class="flex items-center gap-2">
            <span v-if="price?.GFAL !== 0" class="text-neutral-300">≈</span>
            <p class="text-neutral-300">
              {{
                showComingSoon
                  ? ""
                  : "$" + roundNum(price?.USD || recommendedPrice?.USD)
              }}
            </p>
            <CommonRecommendedPriceTooltip
              v-if="showRecommendedPrice"
              :recommended-price="recommendedPrice" />
            <p
              v-if="
                originalPrice?.USD &&
                originalPrice?.USD !== (price?.USD || recommendedPrice?.USD)
              "
              class="text-neutral-300"
              :class="{
                'line-through':
                  originalPrice?.USD !== (price?.USD || recommendedPrice?.USD),
              }">
              {{ "$" + roundNum(originalPrice?.USD) }}
            </p>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="nextPrice && !showComingSoon"
      class="relative rounded-b-md flex sm:justify-center gap-3 pr-8 next-price-layout">
      <BaseIconDoubleArrow
        alt="icon of double arrow facing right"
        class="next-price-layout__icon" />
      <div class="flex flex-col min-w-max sm:flex-1">
        <p class="text-neutral-200">
          {{ $t("main.storeDetail.nextUnitPrice") }}
        </p>
        <div class="flex items-center gap-0.5 sm:gap-1">
          <p class="text-neutral-200 font-bold">
            ${{ roundNum(nextPrice.USD) }}
          </p>
          <NuxtIcon
            name="mdi:arrow-up-circle-outline"
            alt="icon of red arrow pointing up"
            class="mb-0.5 next-price-layout__trend-icon" />
          <p class="font-bold next-price-layout__trend-text">
            +{{ calculateDiscount(price?.USD, nextPrice.USD, 2) }}
            %
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
